export const verifyPhone = 'Verify your cell phone';
